/* eslint-disable react/require-default-props */
import { Badge, Box } from '@material-ui/core';
import IconWrapper from '@src/components/Common/IconWrapper';
import useCallAgentPermissionFlags from '@src/hooks/call/useCallAgentPermissionFlags';
import CallStartIcon from '@src/resources/icons/CallStartIcon';
import React from 'react';

interface CallBadgeProps {
  count: number;
  className?: string;
  children: React.ReactNode;
}

const CallBadge: React.FC<CallBadgeProps> = ({
  count,
  className = '',
  children,
}) => {
  const { isVisible } = useCallAgentPermissionFlags();

  return (
    <Badge
      classes={{ badge: className }}
      invisible={!isVisible || count <= 0}
      badgeContent={
        <Box display="flex" alignItems="center">
          <IconWrapper fontSize={14} style={{ transform: 'rotate(15deg)' }}>
            <CallStartIcon />
          </IconWrapper>
          <Box ml={-0.1}>{count}</Box>
        </Box>
      }
    >
      {children}
    </Badge>
  );
};

export default CallBadge;
